import PropTypes from 'prop-types'
import React from 'react'

import { Container, Title, SubText } from './styles'

const Heading = ({ hide, title, subText }) => {
    return hide ? null : (
        <Container>
            <Title>{title}</Title>
            {subText && <SubText>{subText}</SubText>}
        </Container>
    )
}

Heading.propTypes = {
    title: PropTypes.string.isRequired,
    subText: PropTypes.string.isRequired,
}

export default Heading
